import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { history } from '../../utils/history'
import { IComputedMatch } from '../../types/interfaces'
import { RootState } from '../../reducers'
import {
	getTelephoneSurvey,
	ITelephoneSurveyForm,
	updateTelephoneSurvey
} from '../../reducers/telephoneSurveys/actions'
import TelephoneSurveyCallCard from './components/TelephoneSurveyCallCard'

interface Props {
	computedMatch: IComputedMatch<{ id: number }>
}

const DetailTelephoneSurvey = ({ computedMatch }: Props) => {
	const dispatch = useDispatch()
	const detail = useSelector((state: RootState) => state.telephoneSurveys.detail)
	const survey = detail.data
	const [form, setForm] = useState<ITelephoneSurveyForm>({
		jobIDs: [],
		callStatus: null,
		satisfaction: null,
		note: '',
		scheduledCallAt: null
	})

	useEffect(() => {
		dispatch(getTelephoneSurvey(computedMatch.params.id, (data) => {
			setForm({
				jobIDs: data.jobIDs || [],
				callStatus: data.callStatus,
				satisfaction: data.satisfaction,
				note: data.note || '',
				scheduledCallAt: data.scheduledCallAt || null
			})
		}))
	}, [computedMatch.params.id, dispatch])

	return (
		<div className={'page-wrapper'}>
			<Spin spinning={detail.isLoading}>
				<TelephoneSurveyCallCard
					title={'Detail telefonického prieskumu'}
					jobAddresses={(survey?.jobs || []).map((job) => job.address)}
					cleanerNames={(survey?.cleaners || []).map((cleaner) => cleaner.name)}
					contactName={survey?.trusteeName}
					contactPhone={survey?.trusteePhone}
					contactEmail={null}
					organizationName={survey?.organization?.name}
					trusteeUserID={survey?.trusteeUserID}
					callStatus={form.callStatus}
					satisfaction={form.satisfaction}
					note={form.note || ''}
					scheduledCallAt={form.scheduledCallAt}
					onCallStatusChange={(callStatus) => setForm((prev) => ({ ...prev, callStatus }))}
					onSatisfactionChange={(satisfaction) => setForm((prev) => ({ ...prev, satisfaction }))}
					onNoteChange={(note) => setForm((prev) => ({ ...prev, note }))}
					onScheduledCallAtChange={(scheduledCallAt) => setForm((prev) => ({ ...prev, scheduledCallAt }))}
					onSubmit={(values = {}) => {
						dispatch(updateTelephoneSurvey(computedMatch.params.id, {
							...form,
							...values
						}, () => history.push('/prieskum-spokojnosti')))
					}}
					onCancel={() => history.push('/prieskum-spokojnosti')}
				/>
			</Spin>
		</div>
	)
}

export default DetailTelephoneSurvey
